var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectedCheckboxImage = function SvgSelectedCheckboxImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#a4a4a4",
    fillOpacity: 0,
    strokeWidth: 2,
    ry: 8.90601,
    rx: 8.90601,
    id: "svg_2",
    cy: 10,
    cx: 10,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#a4a4a4",
    ry: 5.96773,
    rx: 5.96773,
    id: "svg_3",
    cy: 10,
    cx: 10,
    strokeWidth: 0,
    fill: "#3f7f7d"
  }))));
};
export { SvgSelectedCheckboxImage as ReactComponent };
export default __webpack_public_path__ + "assets/a6cd5ce4.svg";